import { ProgressReportParams } from '../../../../services/scanService/types';
import {
  ProgressReportFormValues,
  REPORT_MODE,
  ReportMode,
} from '../ProgressReportModal.settings';

export const getProgressReportParams = (
  mode: ReportMode,
  formData: ProgressReportFormValues,
): ProgressReportParams | null => {
  const { scanId, startScanId, endScanId } = formData;
  if (mode === REPORT_MODE.SINGLE) {
    return scanId ? { startScanId: scanId, endScanId: scanId } : null;
  }

  return startScanId && endScanId ? { startScanId, endScanId } : null;
};
